export enum OfferRequestOptionStatusEnum {
  PENDING = "pending",
  DECLINED = "declined",
  PROVIDED = "provided",
  APPROVED = "approved",
}
